module.exports = __webpack_public_path__ + "img/realcase-house.bb62a8d2.png";